import 'arrayq';
import { PureConnect, React } from '../react';
import { Modal } from '../note/modal/index';
import { ParticipantListOfUsergroups } from '../note/noteParticipantSelectPopup/input';
import { usergroupEditor } from './resource';
import cx from './style.less';
import { participantsResource } from '../participant/resource';
import UPDATE_BUTTON_NO from '../focuslock/actions/UPDATE_BUTTON_NO';
import INSPECT_USERGROUP from '../usergroup/actions/USERGROUP_INSPECT';
import FocusLockFocusGuard from '../focuslock/focuslockext';
import windowSelectors from '../window/selectors';
import { IUsergroup } from '../types';
import authmng from '../auth/selectors';
import { Btn } from '../react-toolbox-redesign/button';
import { emptyInspectUser } from './reducer';
import { typeFactions, typeRoleAdmin, typeRoleClerk, typeRolePracticioner } from '../note/question/authmodule/authcheck';

export default PureConnect(`InspectUsergroupModal`)(
    (state) => ({
        inspectItem: state.usergroup.inspect,        
        origin: state.notemenu.origin, 
        screenSmall: windowSelectors.small(state),   
        accountmng: authmng.accountmanager(state),
        user: participantsResource.selectors.items(state).qFirst((itm) => itm.isUser),
    }),
    (dispatch) => ({ 
        stopInspectingUsergroup: () => dispatch(INSPECT_USERGROUP({ usergroup: emptyInspectUser })),
        exitGroup: (item: IUsergroup) => { dispatch(usergroupEditor.actions.UPDATE_CONTINUE({ item })); 
                                           dispatch(INSPECT_USERGROUP({ usergroup: emptyInspectUser }));
        },
    }),
    ({ inspectItem, user, screenSmall, accountmng, stopInspectingUsergroup, exitGroup }) => {
        let inspecting: boolean = !!(inspectItem&&inspectItem.id);
        let item: IUsergroup = inspectItem || emptyInspectUser;
        return (
            <Modal 
                onEscKeyDown={()=> stopInspectingUsergroup()} 
                    visible={inspecting} 
                    type={screenSmall ? 'smallscreen': 'center2nd' }
                    backdrop={true}
                    header={<div className={cx('usergroup-title')}>
                        {item.type === typeRoleAdmin ? 'Rol' :
                        item.type === typeRoleClerk ? 'Rol' :
                        item.type === typeRolePracticioner ? 'Rol' : 
                        item.type === typeFactions? 'Fractie': 'Groep'} raadplegen</div>}
                >                   
                <div className={cx(!inspecting ? 'wcag-invisible' : '', 'fields-container')}  
                    aria-hidden={!inspecting} 
                    aria-labelledby= "Maak een gebruikersgroep aan">
                    <FocusLockFocusGuard 
                        disabled={!inspecting}>   
                        <div className={cx('usergroup-container')}>
                            <div className={cx('input-naam-gebruikersgroep')}>
                                <span className={cx('input-label')}>
                                    {item.type === typeRoleAdmin ? 'Rol' :
                                    item.type === typeRoleClerk ? 'Rol' :
                                    item.type === typeRolePracticioner ? 'Rol' : 
                                    item.type === typeFactions? 'Fractie': 'Groep'}<span className={cx('star')}>*</span></span>
                                {item ? item.name: ''}                      
                            </div>               
                            <div className={cx('participants-of-groep')}>Leden van de {item.type === typeRoleAdmin ? 'rol' :
                                    item.type === typeRoleClerk ? 'rol' :
                                    item.type === typeRolePracticioner ? 'rol' : 
                                    item.type === typeFactions? 'Fractie': 'groep'}</div>         
                            <div className={cx('participants-list-container')}>
                                <ParticipantListOfUsergroups  
                                        selectedparticipantsIDs={item.userIDs}                                                                     
                                /> 
                            </div>
                        </div>
                        <div className={cx('content-buttons-container')}>
                            {item.userIDs.filter((itm) => itm === (user?user.id:'')).length?
                            
                            <Btn
                                type="button"
                                className={'btn'}
                                extraClassNames={'secondary-btn'}
                                aria-label={'Afmelden van groep'}
                                aria-haspopup={false}
                                tabIndex={0}
                                onKeyDown={(evt: any) => {
                                    item.userIDs = item.userIDs.filter((itm) => itm !== (user?user.id:''));
                                    handleEnters(evt, () => exitGroup(item)); 
                                }}
                                onClick={() => {
                                    item.userIDs = item.userIDs.filter((itm) => itm !== (user?user.id:''));
                                    exitGroup(item);}}>
                                <span>AFMELDEN VAN {item.type === typeRoleAdmin ? 'ROL' :
                                    item.type === typeRoleClerk ? 'ROL' :
                                    item.type === typeRolePracticioner ? 'ROL' : 
                                    item.type === typeFactions? 'FRACTIE': 'GROEP'}</span>
                            </Btn>
                            : null }
                        </div>

                        <InspectUsergroupModalButtons></InspectUsergroupModalButtons>
                    </FocusLockFocusGuard>
                </div>         
            </Modal> 
        );
    });

export const InspectUsergroupModalButtons = PureConnect(`InspectUsergroupModalButtons`)(
    (state) => ({
        inspecting: !!state.usergroup.inspect,
        usergroupowner: participantsResource.selectors.items(state).qFirst((itm) => itm.isUser),
        origin: state.notemenu.origin, 
        screenSmall: windowSelectors.small(state),   
        accountmng: authmng.accountmanager(state),
    }),
    (dispatch) => ({ 
        cancel: () => dispatch(usergroupEditor.actions.RESET({ })),
        updateButtonFocus: (buttonNr: number, origin: number, itm: IUsergroup) => {
            dispatch(UPDATE_BUTTON_NO({buttonNo: buttonNr, origin: origin, buttonAction: undefined, lasttoucheditem:itm})); 
        },
        stopInspectingUsergroup: () => dispatch(INSPECT_USERGROUP({ usergroup: undefined })),
    }),
    ({  inspecting, stopInspectingUsergroup }) => {
        var visible = inspecting;      
        return (
            <div className={cx('bottom-panel', (!visible) ? 'wcag-invisible' : '')}
                aria-hidden={!(visible)}
                aria-labelledby="Maak een gebruikersgroep aan">
                {/* WCAG (button):
                            1) no role; they are buttons
                            2) focussable (Tab)
                            3) toggle function: n/a (when true use aria-checked)
                            4) aria-expanded: n/a
                            5) aria-haspopup: n/a  
                            6) aria-labelledby/aria-describedby: ref to label
                            7) icon of button is explained by tekst-> aria-hidden*/}
                <div className={cx('bottom-buttons')}>
                    <div className={cx('buttons-container')}>
                        <Btn
                            type="button"
                            className={'btn'}
                            extraClassNames={'secondary-btn'}
                            aria-label={'Annuleren'}
                            aria-haspopup={false}
                            tabIndex={0}
                            onKeyDown={(evt: any) => {
                                handleEnters(evt,
                                    () => stopInspectingUsergroup());
                            }}
                            onClick={() => stopInspectingUsergroup()}>
                            <span>Annuleren</span>
                        </Btn>

                    </div>

                </div>
            </div>

        );
});

function handleEnters(evt: any, funct: ()=>void) {
    if (evt.key==='Enter') {evt.preventDefault(); funct();}
}   



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/usergroup/inspectModal.tsx